export enum WorkerType {
  Supervised = 'Supervised',
  Autonomous = 'Autonomous',
  AutonomyRule = 'AutonomyRule'
}